var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"survey-cake-page",class:{ 'pdf-mode': _vm.isPDF }},[_c('div',{staticClass:"name GenSenRounded"},[_vm._v(_vm._s(_vm.truncatedName))]),_c('img',{staticClass:"start-page",attrs:{"src":require("@/assets/survey-cake/start-page.jpg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }